function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, Timeout, controllerMixin } from 'oskari-ui/util';
import { FilterHandler } from './Filter/';
import { LayerCollapseHandler } from './LayerCollapse/';
import { GroupingOption } from '../../../model/GroupingOption';
import { Scale } from '../../../model/Scale';
import { GROUPING_PRESET, TEXT_SEARCH_TYPING_TIMEOUT_SETTINGS } from './preset';
var UI_UPDATE_TIMEOUT = 100;
var HEAVY_UI_UPDATE_TIMEOUT = 600;
var ViewHandler = /*#__PURE__*/function (_StateHandler) {
  function ViewHandler(instance) {
    var _this;
    _classCallCheck(this, ViewHandler);
    _this = _callSuper(this, ViewHandler);
    _this.instance = instance;
    _this.sandbox = instance.getSandbox();
    _this.locale = instance.getLocalization();
    var MIN_CHAR_COUNT = TEXT_SEARCH_TYPING_TIMEOUT_SETTINGS.MIN_CHAR_COUNT,
      MAX_CHAR_COUNT = TEXT_SEARCH_TYPING_TIMEOUT_SETTINGS.MAX_CHAR_COUNT,
      MIN = TEXT_SEARCH_TYPING_TIMEOUT_SETTINGS.MIN,
      MAX = TEXT_SEARCH_TYPING_TIMEOUT_SETTINGS.MAX;
    _this.typingTimeoutScale = new Scale({
      min: MIN_CHAR_COUNT,
      max: MAX_CHAR_COUNT,
      rangeMin: MIN,
      rangeMax: MAX,
      outOfRange: MIN
    });

    // Replace GROUPING_PRESET with bundle configuration later.
    var groupingOptions = GROUPING_PRESET.map(function (option) {
      return new GroupingOption(option.key, _this.locale.grouping[option.localeKey], option.method);
    });
    _this.toolingService = _this._createToolingService();
    _this.filterHandler = _this._createFilterHandler();
    var initialGrouping = groupingOptions[0].getKey();
    _this.collapseHandler = _this._createLayerCollapseHandler(initialGrouping);
    _this.state = {
      loading: false,
      updating: false,
      createTools: _this._getCreateTools(),
      grouping: {
        selected: initialGrouping,
        options: groupingOptions
      },
      filter: {
        state: _this.filterHandler.getState(),
        controller: _this.filterHandler.getController()
      },
      collapse: {
        state: _this.collapseHandler.getState(),
        controller: _this.collapseHandler.getController()
      }
    };
    return _this;
  }
  _inherits(ViewHandler, _StateHandler);
  return _createClass(ViewHandler, [{
    key: "_createToolingService",
    value: function _createToolingService() {
      var _this2 = this;
      var service = this.sandbox.getService('Oskari.mapframework.service.LayerListToolingService');
      service.on('add', function (_ref) {
        var tool = _ref.tool;
        if (tool && tool.getTypes().includes(service.TYPE_CREATE)) {
          _this2.updateState({
            createTools: _this2._getCreateTools()
          });
        }
      });
      return service;
    }
  }, {
    key: "_getCreateTools",
    value: function _getCreateTools() {
      var _this3 = this;
      var createTools = Object.values(this.toolingService.getTools()).filter(function (tool) {
        return tool.getTypes().includes(_this3.toolingService.CREATE);
      });
      return createTools;
    }
  }, {
    key: "_createLayerCollapseHandler",
    value: function _createLayerCollapseHandler(initialGrouping) {
      var _this4 = this;
      var handler = new LayerCollapseHandler(this.instance, initialGrouping);
      handler.addStateListener(function (collapseState) {
        _this4.updateState({
          collapse: {
            state: collapseState,
            controller: handler.getController()
          },
          updating: false
        });
      });
      return handler;
    }
  }, {
    key: "_createFilterHandler",
    value: function _createFilterHandler() {
      var _this5 = this;
      var handler = new FilterHandler(this.instance);
      var previousState = null;
      var updateLayerFilters = function updateLayerFilters() {
        previousState = handler.getState();
        var _previousState = previousState,
          activeFilterId = _previousState.activeFilterId,
          searchText = _previousState.searchText;
        _this5.updateState({
          updating: true
        });
        setTimeout(function () {
          return _this5.getCollapseHandler().setFilter(activeFilterId, searchText);
        }, UI_UPDATE_TIMEOUT);
      };
      var typingTimeout = null;
      handler.addStateListener(function (filterState) {
        var searchText = filterState.searchText;
        var searchTextChanged = previousState && previousState.searchText !== searchText;
        var immediateStateChange = {
          filter: {
            state: filterState,
            controller: _this5.state.filter.controller
          }
        };
        if (!searchTextChanged) {
          updateLayerFilters();
          _this5.updateState(immediateStateChange);
          return;
        }
        if (typingTimeout && typingTimeout.isPending()) {
          typingTimeout.cancel();
        }
        var textLength = searchText ? searchText.length : 0;
        typingTimeout = new Timeout(updateLayerFilters, _this5.typingTimeoutScale.getValue(textLength));
        _this5.updateState(immediateStateChange);
      });
      return handler;
    }
  }, {
    key: "getFilterHandler",
    value: function getFilterHandler() {
      return this.filterHandler;
    }
  }, {
    key: "getCollapseHandler",
    value: function getCollapseHandler() {
      var grouping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.grouping.selected;
      if (typeof GROUPING_PRESET.find(function (p) {
        return p.key === grouping;
      }) === 'undefined') {
        // grouping not recognized -> ignore
        return null;
      }
      this.collapseHandler.setGroupingType(grouping);
      return this.collapseHandler;
    }
  }, {
    key: "loadLayers",
    value: function loadLayers() {
      var _this6 = this;
      var mapLayerService = this.sandbox.getService('Oskari.mapframework.service.MapLayerService');
      this.updateState({
        loading: true
      });
      var successCB = function successCB() {
        _this6.updateState({
          loading: false
        });
      };
      var failureCB = function failureCB() {
        _this6.updateState({
          loading: false,
          error: _this6.locale.errors.loadFailed
        });
        alert(_this6.locale.errors.loadFailed);
      };
      var forceProxy = this.instance.conf && this.instance.conf.forceProxy;
      mapLayerService.loadAllLayerGroupsAjax(successCB, failureCB, {
        forceProxy: forceProxy
      });
    }
  }, {
    key: "setGrouping",
    value: function setGrouping(groupingKey) {
      var handler = this.getCollapseHandler(groupingKey);
      if (!handler) {
        return;
      }
      this.updateState({
        grouping: {
          options: this.state.grouping.options,
          selected: groupingKey
        },
        updating: true
      });
      var _this$state$filter$st = this.state.filter.state,
        activeFilterId = _this$state$filter$st.activeFilterId,
        searchText = _this$state$filter$st.searchText;
      setTimeout(function () {
        return handler.setFilter(activeFilterId, searchText);
      }, HEAVY_UI_UPDATE_TIMEOUT);
    }
  }]);
}(StateHandler);
export var LayerListHandler = controllerMixin(ViewHandler, ['setGrouping']);